import React from "react";
import { Dna } from "react-loader-spinner";
import { LoaderContainer } from "./styles";

const Spinner: React.FC = () => {
  return (
    <LoaderContainer data-testid="spinner">
      <Dna
        visible={true}
        height={100}
        width={100}
        ariaLabel="dna-loading"
        wrapperStyle={{}}
        wrapperClass="dna-wrapper"
      />
    </LoaderContainer>
  );
};

export default Spinner;
